import React from 'react';
import { Button } from './ui/Button';
import { Check, ShieldCheck, Lock } from 'lucide-react';
export function PricingSection() {
  return <section id="compra" className="py-20 bg-gradient-to-b from-white to-slate-50" data-id="element-55">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="max-w-4xl mx-auto" data-id="element-57">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-slate-200" data-id="element-58">
            <div className="bg-slate-900 p-6 text-center" data-id="element-59">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-60">
                Todo el sistema hoy por un único pago
              </h2>
              <p className="text-slate-400 text-sm" data-id="element-61">
                Acceso inmediato • Material digital • Descarga segura
              </p>
            </div>

            <div className="p-8 md:p-12 text-center" data-id="element-62">
              <div className="flex flex-col items-center justify-center mb-8" data-id="element-63">
                <span className="text-slate-400 text-xl line-through mb-2 font-medium" data-id="element-64">
                  Precio regular: $45.000
                </span>
                <div className="flex items-start justify-center gap-1" data-id="element-65">
                  <span className="text-3xl font-bold text-teal-600 mt-2" data-id="element-66">
                    $
                  </span>
                  <span className="text-7xl font-bold text-slate-900 tracking-tight" data-id="element-67">
                    19.990
                  </span>
                </div>
                <span className="inline-block bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-bold mt-4" data-id="element-68">
                  OFERTA ESPECIAL HOY
                </span>
              </div>

              <div className="grid md:grid-cols-2 gap-4 max-w-lg mx-auto mb-10 text-left" data-id="element-69">
                {['Pago único', 'Acceso inmediato', 'Descarga segura', 'Sin suscripciones', 'Actualizaciones incluidas', 'Soporte prioritario'].map((item, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-70">
                    <div className="bg-green-100 rounded-full p-1" data-id="element-71">
                      <Check className="w-3 h-3 text-green-600" data-id="element-72" />
                    </div>
                    <span className="text-slate-600 font-medium" data-id="element-73">{item}</span>
                  </div>)}
              </div>

              <Button href="https://checkout.ebookditales.com/cart/42846653874239:1" variant="primary" fullWidth className="text-xl py-6 shadow-xl shadow-teal-200/50 mb-6 max-w-md mx-auto" data-id="element-74">
                Acceder al Mega Pack de Dislexia Ahora
              </Button>

              <div className="flex items-center justify-center gap-2 text-slate-500 text-sm mb-8" data-id="element-75">
                <Lock className="w-4 h-4" data-id="element-76" />
                <span data-id="element-77">Pago 100% seguro y encriptado</span>
              </div>

              {/* Guarantee Box */}
              <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 max-w-2xl mx-auto" data-id="element-78">
                <div className="flex flex-col md:flex-row items-center gap-4 text-left" data-id="element-79">
                  <div className="bg-amber-100 p-3 rounded-full flex-shrink-0" data-id="element-80">
                    <ShieldCheck className="w-8 h-8 text-amber-600" data-id="element-81" />
                  </div>
                  <div data-id="element-82">
                    <h3 className="font-bold text-slate-900 mb-1" data-id="element-83">
                      Garantía total de 7 días
                    </h3>
                    <p className="text-slate-600 text-sm" data-id="element-84">
                      Probá el sistema durante una semana. Si sentís que no te
                      aporta claridad, orden o ahorro de tiempo, te devolvemos
                      el 100% del dinero. Sin preguntas.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 text-center text-slate-500 text-sm" data-id="element-85">
            <p data-id="element-86">
              Este producto es digital y se envía automáticamente por correo
              luego de la compra.
            </p>
          </div>
        </div>
      </div>
    </section>;
}